// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';

export default class Search extends React.Component {

    render = () => {
        return (<div
            className={"search " + (this.props.className ? this.props.className : "")}
            style={this.props.activeZ && this.props.query.length > 0 ? {
                zIndex: this.props.activeZ
            } : {}}
        >
            <input
                id="search"
                name="search"
                type="text"
                value={this.props.query}
                onChange={(e) => this.props.search(e.target.value)}
                placeholder={this.props.placeholder ? this.props.placeholder : "Search..."}
                style={this.props.style ? this.props.style : {}}
                className={this.props.inputClassName ? this.props.inputClassName : ""}
                disabled={this.props.disabled}
                autoComplete="off"
            />
            <div className="search-icon hover-gray">
                <img
                    src="https://static.stax.ai/images/icons/search.png"
                    alt="Search"
                />
            </div>
            {this.props.searching && <div className="search-bar-loading">
                <Loading
                    type="spin"
                    color="rgb(160,160,160)"
                    height={24}
                    width={24}
                />
            </div>}
        </div>);
    }

}